import { render, staticRenderFns } from "./VoidReceiptDialog.vue?vue&type=template&id=edda6e90"
import script from "./VoidReceiptDialog.vue?vue&type=script&lang=js"
export * from "./VoidReceiptDialog.vue?vue&type=script&lang=js"
import style0 from "./VoidReceiptDialog.vue?vue&type=style&index=0&id=edda6e90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports